import { useMemo } from 'react';

import { useEventsQuery, useWeddingWebsiteQuery } from '../../generated/graphql';

const RSVPNOTE_QUESTION_TYPE = 'RSVPNote';

export function useSeeWorkflow(): boolean | null | undefined {
  const { data } = useWeddingWebsiteQuery();

  return data?.guestWedding?.rsvpWorkflow;
}

export function useWorkflowUnstartedState(): { loading: boolean; isUnstartedState: boolean } {
  const { data } = useWeddingWebsiteQuery();
  const { data: eventData, loading } = useEventsQuery();

  const guestWedding = data?.guestWedding;

  const unstartedEvents: boolean = useMemo(() => {
    const eventsOnOrWithQuestions =
      eventData?.events?.filter(
        event => event.requireRsvp === true || (event.questions && event.questions.length > 0)
      ) || [];
    return eventsOnOrWithQuestions?.length <= 0;
  }, [eventData]);

  const noGeneralQuestions: boolean = useMemo(() => {
    const notNoteQuestions = guestWedding?.questions?.filter(q => q.type !== RSVPNOTE_QUESTION_TYPE) || [];
    return notNoteQuestions?.length <= 0;
  }, [guestWedding]);

  return { loading, isUnstartedState: unstartedEvents && noGeneralQuestions };
}
